const ACTIVITY_TYPE = {
  QUIZ: { name: "quiz", display_name: "Quiz" },
  WRITE_PROMPT: { name: "write_prompt", display_name: "Write Prompt" },
  ANNOTATIONS: { name: "annotations", display_name: "Annotations" },
  POWER_WORDS: { name: "power_words", display_name: "Power words" },
  GUIDED_HIGHLIGHTING: {
    name: "guided_highlighting",
    display_name: "Guided highlighting",
  },
  CHECKS_FOR_UNDERSTANDING: {
    name: "checks_for_understanding",
    display_name: "Checks for understanding",
  },
};

/**
 * The source of truth for all query params used in the grading page.
 * All query params should be added here and be in sync with the monolith
 * https://github.com/newsela/newsela/blob/main/newsela/static/three-oh/src/routes/Read/components/GradingMode/constants.jsx
 *
 * @property {string} activityType - The activity type filter
 * @property {string} classroom - The classroom filter
 * @property {string} lexileLevel - The lexile level filter
 * @property {string} assignmentId - The assignment id
 * @property {string} question - The question position when activityType is a quiz
 * @return {object} - The query params for grading page
 */
const GRADING_QUERY_PARAMS = {
  contentId: {
    param: "contentId",
  },
  assignmentId: {
    param: "assignmentId",
  },
  activityType: {
    param: "activityType",
    required: true,
  },
  classroom: {
    param: "classroom",
    required: false,
  },
  lexileLevel: {
    param: "level",
    required: true,
  },
  activityId: {
    param: "activityId",
  },
  collection: {
    param: "collectionId",
  },
  question: {
    param: "question",
  },
  returnUrl: {
    param: "returnUrl",
  },
  student: {
    param: "student",
  },
  legacyArticleId: {
    param: "legacyArticleId",
  },
  headerId: {
    param: "headerId",
  },
  isCanvasMode: {
    param: "isCanvasMode",
    required: false,
  },
  studentUniqueId: {
    param: "studentUniqueId",
    required: false,
  },
  assignmentGroupId: {
    param: "assignmentGroupId",
    required: false,
  },
};

const ARTICLE_BODY_ORIGIN = {
  GRADING_PAGE: "GRADING_PAGE",
  VIEW_PAGE: "VIEW_PAGE",
};

export { ACTIVITY_TYPE, GRADING_QUERY_PARAMS, ARTICLE_BODY_ORIGIN };
